<template>
  <div>
    <div class="footer">
      <div class="footerNav">
        <div class="content w">
          <dl :style="{ width: '25%' }">
            <dt>
              <router-link to="/contactUs">联系我们</router-link>
            </dt>
            <dd>
              <i class="line">
                <span class="lineLeft"></span>
                <span class="lineRight"></span>
              </i>
            </dd>
            <dd>
              <router-link to="#">地址：深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心</router-link>
            </dd>
            <dd>
              <router-link to="#">电话：0755-23209701</router-link>
            </dd>
            <dd>
              <router-link to="#">邮箱：yunjiuhong@163.com</router-link>
            </dd>
            <dd>
              <div class="imgBox">
                <img :src="src.code" alt="" />
                <img :src="src.xcx" alt="" />
              </div>
              <div class="imgTitle">（扫码关注）</div>
            </dd>
          </dl>
          <dl>
            <dt>
              <router-link to="/aboutUs?navIndex=0">关于我们</router-link>
            </dt>
            <dd>
              <i class="line">
                <span class="lineLeft"></span>
                <span class="lineRight"></span>
              </i>
            </dd>
            <dd>
              <router-link to="/aboutUs?navIndex=0">公司架构</router-link>
            </dd>
            <dd>
              <router-link to="/aboutUs?navIndex=1">管理团队</router-link>
            </dd>
            <dd>
              <router-link to="/aboutUs?navIndex=2">企业荣誉</router-link>
            </dd>
            <dd>
              <router-link to="/index?navIndex=1">企业文化</router-link>
            </dd>
          </dl>
          <dl>
            <dt>
              <router-link to="/enterprise?navIndex=0">企业服务</router-link>
            </dt>
            <dd>
              <i class="line">
                <span class="lineLeft"></span>
                <span class="lineRight"></span>
              </i>
            </dd>
            <dd>
              <router-link to="/enterprise?navIndex=0">人力资源系统开发</router-link>
            </dd>
            <dd>
              <router-link to="/enterprise?navIndex=1">人才梯队打造</router-link>
            </dd>
            <!-- <dd>
              <router-link to="#">劳务派遣</router-link>
            </dd> -->
            <dd>
              <router-link to="/enterprise?navIndex=4">企业管理咨询</router-link>
            </dd>
            <dd>
              <router-link to="/enterprise?navIndex=5">BPO商业流程外包</router-link>
            </dd>
            <dd>
              <router-link to="/enterprise?navIndex=6">合作方式</router-link>
            </dd>
            <!-- <dd>
              <router-link to="#">成功案例</router-link>
            </dd> -->
          </dl>
          <dl>
            <dt>
              <router-link to="/newsConsult">媒体新闻</router-link>
            </dt>
            <dd>
              <i class="line">
                <span class="lineLeft"></span>
                <span class="lineRight"></span>
              </i>
            </dd>
            <dd>
              <router-link to="/newsConsult">新闻资讯</router-link>
            </dd>
            <dd>
              <router-link to="/videoMedia">视频媒体</router-link>
            </dd>
            <dd>
              <router-link to="/qiyeConsult">企业资讯</router-link>
            </dd>
            <!-- <dd>
              <router-link to="#">行业热门</router-link>
            </dd> -->
          </dl>
        </div>
      </div>
      <div class="copyRight">
        <div class="itemBox">
          <div>深圳市云久鸿劳务派遣有限公司 版权所有 2022 </div>
          <div>网站备案号： <a style="color:#fff" href="https://beian.miit.gov.cn/">粤ICP备18057440号</a></div>
        </div>
      </div>
    </div>
    <div class="line_mobile"></div>
    <div class="footer_mobile">
      <div class="footer_left">
        <div class="item_title">联系我们</div>
        <div class="item_line"></div>
        <div class="item_content">
          <p>电话：0755-23209701</p>
          <p>邮箱：yunjiuhong@163.com</p>
          <p>地址：深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心</p>
        </div>
      </div>
      <div class="footer_right">
        <div class="footer_right_item">
          <div class="item_img">
            <img :src="src.code" alt="" />
          </div>
          <div class="item_text">云久鸿公众号</div>
        </div>
        <div class="footer_right_item">
          <div class="item_img">
             <img :src="src.xcx" alt="" />
          </div>
          <div class="item_text">久聘求职平台</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import src from '../utils/assets'
export default {
  data() {
    return {
      src:src
    }
  },
  methods: {
    btnclick() {
      console.log(1);
      this.$router.push({
        path: "/index",
        query: {
          navIndex: 3,
        },
      });
    },
  },
};
</script>

<style lang="less">
// 移动端
@media screen and (max-width: 999px) {
  .footer {
    display: none;
  }
  .line_mobile {
    width: 100%;
    height: 10px;
    background-color: #f8f8fa;
  }
  .footer_mobile {
    font-size: 10px;
    width: 100%;
    height: 140px;
    display: flex;
    padding: 10px 0;
    transform: scale(0.95);
    .footer_left {
      // width: 60%;
      .item_title {
        font-size: 16px;
        font-weight: 700;
        border-bottom: 1px #8c8c8c solid;
        line-height: 20px;
      }
      .item_line {
        width: 20px;
        border: 1px #da261d solid;
      }
      .item_content {
        // transform: scale(0.9);
        line-height: 20px;
      }
    }
    .footer_right {
      margin-top: 20px;
      display: flex;
      // width: 40%;
      .footer_right_item {
        .item_img {
          width: 50px;
          height: 50px;
          margin: 5px auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_text {
          transform: scale(0.9);
        }
      }
    }
  }
}
// PC端
@media screen and (min-width: 999px) {
  .footer_mobile {
    display: none;
  }
  .footer {
    width: 100%;
    height: 515px;
    margin-top: 10px;
    .footerNav {
      width: 100%;
      height: 515px;
      background: #424242;
      display: flex;
      padding: 80px 10%;
      dl {
        float: left;
        margin-top: 18px;
        padding-right: 40px;
        width: 20%;
      }
      dl:nth-child(4) {
        padding-right: 0;
      }
      dt {
        height: 50px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        a {
          color: #eeeeee;
        }
      }
      dd {
        height: 28px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;

        a {
          color: #9a9a9a;
        }
        .imgBox {
          margin-top: 50px;
          img {
            margin-right: 32px;
          }
        }
        .imgTitle {
          // text-align: center;
          margin-top: 10px;
          text-indent: 80px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #da271e;
        }
      }
      a:hover {
        color: #eeeeee;
        text-decoration: underline;
      }

      .line {
        width: 100%;
        height: 2px;
        display: flex;
        .lineLeft {
          width: 20%;
          height: 2px;
          background: #da261e;
        }
        .lineRight {
          width: 80%;
          height: 2px;
          background: #d9d9d9;
        }
      }
    }
    .copyRight {
      width: 100%;
      height: 280px;
      background: #383838;
      .itemBox {
        padding-top: 85px;
        div {
          width: 100%;
          text-align: center;
          font-size: 19px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eeeeee;
          margin-top: 10px;
        }
      }
    }
  }
  .header_mobile {
    display: none;
  }
}
</style>
